<template>
  <div>
    <h4 class="header" v-html="data.question" />
    <form class="ui form">
      <label class="ui bold text">Your answer:</label>
      <input type="text" v-model="answer" />
    </form>
    <p class="disclaimer"><i>*Interactions are designed to help learning retention only. Interaction data is not stored for reporting.</i></p>
    <div v-if="submitted" :class="`ui ${ isCorrect ? 'success' : 'error' } message`">{{ messageText }}</div>
  </div>
</template>

<script>
import ScormService from '@/services/scorm/scorm.js';

export default {
  name: 'FillInTheBlank',
  props: ['id', 'type', 'data', 'standard'],
  data() {
    return {
      answer: '',
      submitted: false,
      isCorrect: false,
    };
  },
  computed: {
    messageText() {
      return this.isCorrect ? this.data.correct_feedback : this.data.incorrect_feedback;
    },
  },
  methods: {
    checkIsValid() {
      this.$emit('valid', this.answer.length > 0);
    },
    saveSCORMInteraction() {
      const scormData = {
        id: this.id,
        type: this.type,
        isCorrect: this.isCorrect,
        answer: this.answer,
        description: this.data.question,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
    submit() {
      this.isCorrect = false;
      const pregex = /[.,/#!$%^&*;:{}=\-_`~()]/g;
      const answer = this.answer.toLowerCase().trim().split(' ').join('').replace(pregex, '');
      this.data.correct_answers.forEach(a => {
        const ca = a.toLowerCase().trim().split(' ').join('').replace(pregex, '');
        if (ca === answer) {
          this.isCorrect = true;
        };
      });
      this.submitted = true;
      if (this.standard === 'SCORM_2004') {
        this.saveSCORMInteraction();
      }
      this.$emit('valid', false);
    },
  },
  watch: {
    answer() {
      this.submitted = false;
      this.checkIsValid();
    },
  },
};
</script>
